import { Apps } from "@mui/icons-material";
import { IconButton, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import { NerdAppsMenu } from "@nerdjs/nerd-ui";
import { MouseEvent, ReactElement, useState } from "react";
import { useTranslation } from "react-i18next";
import { currentUserAppsSelector } from "../../redux/appStatus/appStatusSelector";
import { RouterConfig } from "../config/routerConfig";
import { useAppSelector } from "../hooks";
import { StyledMenu } from "../nerdAppBar/nerdAppBar";
import { Button } from "@mui/joy";

/**
 *
 * @returns {ReactElement} NerdAppsMenuWrapper
 */
export default function NerdAppsMenuWrapper(): ReactElement {
  const apps = useAppSelector(currentUserAppsSelector);
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const { t } = useTranslation();
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
      {md ? (
        <Button
          size="sm"
          variant="plain"
          onClick={(e: any) => handleClick(e)}
          startDecorator={<Apps />}
        >
          {t("entities:app.entity")}
        </Button>
      ) : (
        <Tooltip title={`${t("entities:app.entity")}`}>
          <IconButton color="primary" size="small" onClick={handleClick}>
            <Apps />
          </IconButton>
        </Tooltip>
      )}
      <StyledMenu
        id={id}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "310px",
          }}
        >
          {apps && <NerdAppsMenu homePath={RouterConfig.root} apps={apps} />}
        </div>
      </StyledMenu>
    </>
  );
}
